import React, { useEffect, useMemo, useState, useRef } from 'react'
import CommonLayout from "layouts/DashboardLayout";
import { Box, Card, Typography, Grid, Button, FormHelperText, Stack, Table, CircularProgress, TextField, FormControl, InputLabel, Select, MenuItem, IconButton, Dialog, DialogTitle, DialogContent, Autocomplete } from "@mui/material";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CloseIcon from '@mui/icons-material/Close';
import { openSnackbar } from '../../../redux/slices/common';
import { updateDriverStatusApi, updateDriverTasksApi, updateOrderStatusApi } from '../../../redux/slices/hyperdrive/setting';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import InfiniteScrollList from 'common/component/Hyperwolf/InfiniteScrollList';
import { fetchDrivers, fetchDriversOnDuty, fetchRegionterminal } from '../../../redux/slices/hyperdrive/driverAnalytics';
import WebFlowIndex from './WebFlow';
import { openCustomDrawer } from '../../../redux/slices/modalSlice';
import MapDrive from 'layouts/Hyperdrive/Home/MapDrive';
import Loader from 'common/Loader';
import FiltersDriverTasks from 'components/hyperdrive/filtersDriverTasks';

const IndexHyperdriveTesting = () => {
    const dispatch = useDispatch()
    const { driverList = {}, detailLoading ,terminalLoading} = useSelector(state => state.driverAnalyticsHyperDrive);
    const { isupdateOrderStatusApioading, updateDriverTasksApiLoading } = useSelector(state => state?.commonHyperdrive)
    const [errors, setErrors] = useState({});
    const [isMapModalOpen, setIsMapModalOpen] = useState(false);
    const [mapKey, setMapKey] = useState(0);

    const [updateOrderStatus, setUpdateOrderStatus] = useState({
        orderId: "",
        status: ""
    })

    const [driverData, setDriverData] = useState({
        driverId: "",
        taskUrl: ""
    })

    const [updateDriverStatus, setUpdateDriverStatus] = useState({
        "fleetId": "",
        "fleetOnDutyStatus": true,
        "lat": '',
        "long": ''
    })

    const [onDriverStatusList, setOnDriverStatusList] = useState()

    const showResponseMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }))
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }))
        }
    }

    //  ------------------------Update Order Status-------------------------------------------

    const handleUpdateOrderStatus = () => {
        if (!(updateOrderStatus?.orderId && updateOrderStatus?.status)) {
            setErrors({ ...errors, orderStatus: 'Task Id & Status is required' });
            return
        }
        dispatch(updateOrderStatusApi(updateOrderStatus))
            .unwrap()
            .then(res => {
                setUpdateOrderStatus({
                    orderId: "",
                    status: ""
                })
                showResponseMessage(res?.message, 'success');
            })
            .catch(err => {
                showResponseMessage(err?.message, 'error');
            });
    }

    // --------------------------Driver Management -----------------------------

    const driverSelectHandler = (driver) => {
        setUpdateDriverStatus(prev => ({
            ...prev,
            fleetId: driver
        }))
        setErrors(prev => ({
            ...prev,
            DriverStatus: ''
        }))
        setErrors(prev => ({
            ...prev,
            DriverLocation: ''
        }));
    };

    const handleUpdateDriverLocationStatus = () => {
        if (!(updateDriverStatus?.fleetId && updateDriverStatus?.lat && updateDriverStatus?.long)) {
            setErrors({ ...errors, DriverLocation: 'Driver Id & lat & lng is required' });

            return
        }
        const payload = {
            "fleetId": updateDriverStatus?.fleetId,
            "lat": Number(updateDriverStatus?.lat),
            "long": Number(updateDriverStatus?.long),
        }
        dispatch(updateDriverStatusApi(payload))
            .unwrap()
            .then(res => {
                // setUpdateDriverStatus({
                //     "fleetId": "",
                //     "lat": '',
                //     "long": ''
                // })
                showResponseMessage(res?.message, 'success');
            })
            .catch(err => {
                showResponseMessage(err?.message, 'error');
            });
    }

    const handleDriveStatus = (status) => {
        if (!(updateDriverStatus?.fleetId)) {
            setErrors({ ...errors, DriverStatus: 'Driver Id  is required' });
            return
        }
        const payload = {
            "fleetId": updateDriverStatus?.fleetId,
            "fleetOnDutyStatus": status,
        }
        dispatch(updateDriverStatusApi(payload))
            .unwrap()
            .then(res => {
                onDutyDrivers()

                // setUpdateDriverStatus({
                //     "fleetId": "",
                //     "lat": '',
                //     "long": ''
                // })
                showResponseMessage(res?.message, 'success');
            })
            .catch(err => {
                showResponseMessage(err?.message, 'error');
            });
    }


    const handleDriverTasks = () => {
        if (!(driverData?.driverId)) {
            setErrors({ ...errors, taskLocation: 'Driver Id is required' });

            return
        }
        dispatch(updateDriverTasksApi(driverData?.driverId))
            .unwrap()
            .then(res => {

                const url = createGoogleMapsUrl(res?.data)

                setDriverData(prev => ({
                    ...prev,
                    taskUrl: url
                }))

                showResponseMessage(res?.message, 'success');
            })
            .catch(err => {
                showResponseMessage(err?.message, 'error');
            });
    }

    //-------------------------------- Route URL Generator--------------------------------
    const routeSelectHandler = (driver) => {
        setDriverData(prev => ({
            ...prev,
            driverId: driver,
            taskUrl: ""
        }))
        setErrors(prev => ({
            ...prev,
            taskLocation: ""
        }))
    };

    const handleRedirect = (url) => {
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    const optionsListDriver = useMemo(() => {
        return driverList?.data?.map((driver => {
            return {
                value: driver?._id,
                label: driver?.driverName
            };
        }));
    }, [driverList]);

    const extractCoordinates = (tasks) => {

        // Skip tasks of breakTask type
        return tasks
            .filter(task => task.taskType !== 'breakTask' && task.taskStatus !== 'cancelled').map(task => {
                return {
                    lat: task.address.latitude,
                    lng: task.address.longitude
                }
            });
    };

    const createGoogleMapsUrl = (data) => {
        const coordinates = extractCoordinates(data);

        if (coordinates.length === 0) return '';

        const waypoints = coordinates.map(coord => `${coord.lat},${coord.lng}`).join('/');
        return `https://www.google.com/maps/dir/${waypoints}`;
    };

    const resetDriverData = () => {
        setUpdateDriverStatus({
            "fleetId": "",
            "lat": '',
            "long": ''
        })
    }

    const onDutyDrivers = () => {
        const payload = {
            status: true,
            skip: 0,
            limit: 200
        }
        dispatch(fetchDriversOnDuty(payload)).unwrap().then((res) => {
            setOnDriverStatusList(res?.data)
        })
    }

    useEffect(() => {
        onDutyDrivers()
    }, [])

    const [dataPassComponent, setDataPassComponent] = useState({});
    const driverZoomOnMapRef = useRef({});

    //  dialog
    const getDataFromChild = (dateRange, formDataStatus) => {
        const filterData = { ...dateRange, ...formDataStatus };
        setDataPassComponent(filterData);

    };

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const [anchorTask, setAnchorTask] = React.useState(null);
    const opentask = Boolean(anchorTask);


    //  region terminal
    const syncRegion = () => {
        dispatch(fetchRegionterminal()).unwrap().then((res) => {
            showResponseMessage('Regions Synced Successfully', 'success');
         }).catch(err => {
            showResponseMessage(err?.message, 'error');
        });
    }

    return (
        <CommonLayout>
            <Box p={{ xs: 2, sm: 3, lg: 4 }}>
                <Grid container spacing={3} className="hyperdrive-testing">

                    {/* Mini Map Preview at Top */}
                    <Grid item xs={12}>
                        <Card sx={{
                            p: 2,
                            borderRadius: 3,
                            boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                            border: '1px solid #e5e7eb',
                            position: 'relative'
                        }}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1.5}>
                                <Typography variant='subtitle1' fontWeight="600" color="#111827" sx={{ fontSize: '1.0625rem' }}>Live Map Preview</Typography>

                                <IconButton
                                    onClick={() => {
                                        setMapKey(prev => prev + 1);
                                        setIsMapModalOpen(true);
                                    }}
                                    sx={{
                                        bgcolor: '#0062ff',
                                        color: '#ffffff',
                                        width: 36,
                                        height: 36,
                                        '&:hover': { bgcolor: '#0052cc' },
                                        '&:active': { bgcolor: '#0052cc' }
                                    }}
                                >
                                    <FullscreenIcon sx={{ fontSize: 20 }} />
                                </IconButton>
                            </Stack>
                            <Box sx={{
                                height: 200,
                                borderRadius: 2,
                                overflow: 'hidden',
                                border: '1px solid #e5e7eb'
                            }}>
                                <MapDrive testingPanel={true} />
                            </Box>
                        </Card>
                    </Grid>

                    {/* Map Modal/Dialog */}
                    <Dialog
                        open={isMapModalOpen}
                        onClose={() => setIsMapModalOpen(false)}
                        maxWidth="xl"
                        fullWidth
                        PaperProps={{
                            sx: {
                                borderRadius: 3,
                                minHeight: '95vh'
                            }
                        }}
                    >
                        <DialogTitle sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #e5e7eb',
                            pb: 2
                        }}>
                            {/* <Typography variant='h6' fontWeight="600" color="#111827">Live Map View</Typography> */}
                            <FiltersDriverTasks
                                sendDataToChild={getDataFromChild}
                                setAnchorEl={setAnchorEl}
                                setAnchorTask={setAnchorTask}
                                anchorEl={anchorEl}
                                anchorTask={anchorTask}
                                opentask={opentask}
                                open={open}
                            />
                            <Autocomplete
                                style={{ width: "20%" }}
                                id="tags-outlined"
                                options={onDriverStatusList || []}
                                getOptionLabel={(option) => option.driverName}
                                filterSelectedOptions
                                clearIcon={false}
                                onChange={(val, selectedOption, _) => {
                                    driverZoomOnMapRef.current?.zoomOnDriver(selectedOption)
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Find Driver"
                                    />
                                )}
                            />

                            <IconButton
                                onClick={() => setIsMapModalOpen(false)}
                                sx={{
                                    color: '#6b7280',
                                    '&:hover': { bgcolor: '#f3f4f6', color: '#374151' },
                                    '&:active': { bgcolor: '#f3f4f6', color: '#374151' }
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent sx={{ p: 0, height: '70vh' }}>
                            <Box sx={{ height: '100%', width: '100%' }}>
                                <MapDrive key={`map-modal-${mapKey}`} testingPanel={true} dataPassComponent={dataPassComponent} driverZoomOnMapRef={driverZoomOnMapRef} />
                            </Box>
                        </DialogContent>
                    </Dialog>

                    <Grid item xs={12} md={12}>
                        <div className="left-panel">
                            <WebFlowIndex
                                updateOrderStatus={updateOrderStatus}
                                setUpdateOrderStatus={setUpdateOrderStatus}
                                handleUpdateOrderStatus={handleUpdateOrderStatus}
                                isupdateOrderStatusApioading={isupdateOrderStatusApioading}
                                errors={errors}
                                setErrors={setErrors}
                            />

                            <Grid container spacing={3} mb={3}>
                                {/* Route URL Generator and Driver Management - Side by Side */}
                                <Grid item xs={12} md={6}>
                                    <Card sx={{
                                        p: 3.5,
                                        borderRadius: 3,
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                                        border: '1px solid #e5e7eb',
                                        height: '100%'
                                    }}>
                                        <div className="section">
                                            <Typography variant='subtitle1' mb={2.5} fontWeight="600" color="#111827" sx={{ fontSize: '1.0625rem' }}>Route URL Generator</Typography>
                                            <Stack spacing={3}>
                                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="flex-start">
                                                    <Box flex={1}>
                                                        <InfiniteScrollList
                                                            dataFetcher={fetchDrivers}
                                                            optionSelectHandler={routeSelectHandler}
                                                            options={optionsListDriver}
                                                            value={driverData?.driverId}
                                                            label='Select Driver'
                                                        />
                                                        {errors?.taskLocation && <FormHelperText error sx={{ mt: 0.5 }}>{errors?.taskLocation}</FormHelperText>}
                                                    </Box>

                                                    <Button
                                                        onClick={handleDriverTasks}
                                                        variant="contained"
                                                        disabled={updateDriverTasksApiLoading}
                                                        sx={{
                                                            minWidth: 200,
                                                            height: 47,
                                                            bgcolor: '#0062ff',
                                                            color: '#ffffff',
                                                            fontWeight: 600,
                                                            textTransform: 'none',
                                                            borderRadius: 2.5,
                                                            boxShadow: '0 1px 2px rgba(0,98,255,0.1)',
                                                            '&:hover': { bgcolor: '#0052cc', boxShadow: '0 4px 12px rgba(0,98,255,0.2)' },
                                                            '&:active': { bgcolor: '#0052cc', boxShadow: '0 1px 2px rgba(0,98,255,0.1)' }
                                                        }}
                                                    >
                                                        {updateDriverTasksApiLoading ? "Generating..." : "Generate Route URL"}
                                                    </Button>
                                                </Stack>

                                                <Box>
                                                    <Typography variant='body2' mb={1.5} fontWeight="600" color="#6b7280" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '0.6875rem' }}>Generated Route URL</Typography>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        value={driverData?.taskUrl}
                                                        InputProps={{ readOnly: true }}
                                                    // sx={{
                                                    //     '& .MuiOutlinedInput-root': {
                                                    //         borderRadius: 2,
                                                    //         backgroundColor: '#f9fafb',
                                                    //         '& fieldset': { borderColor: '#e5e7eb' }
                                                    //     }
                                                    // }}
                                                    />
                                                    <Box mt={2}>
                                                        <Button
                                                            disabled={!driverData?.taskUrl}
                                                            variant="contained"
                                                            onClick={() => handleRedirect(driverData?.taskUrl)}
                                                            sx={{
                                                                minWidth: 160,
                                                                height: 44,
                                                                bgcolor: '#0062ff',
                                                                color: '#ffffff',
                                                                fontWeight: 600,
                                                                textTransform: 'none',
                                                                borderRadius: 2.5,
                                                                boxShadow: '0 1px 2px rgba(0,98,255,0.1)',
                                                                '&:hover': { bgcolor: '#0052cc', boxShadow: '0 4px 12px rgba(0,98,255,0.2)' },
                                                                '&:active': { bgcolor: '#0052cc', boxShadow: '0 1px 2px rgba(0,98,255,0.1)' },
                                                                '&:disabled': { bgcolor: '#9ca3af', color: '#ffffff' }
                                                            }}
                                                        >
                                                            Open in Browser
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </div>
                                    </Card>
                                </Grid>

                                {/* Driver Management */}
                                <Grid item xs={12} md={6}>
                                    <Card sx={{
                                        p: 3.5,
                                        borderRadius: 3,
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <div className="section">
                                            <Stack direction="row" justifyContent="space-between" flexWrap="wrap" alignItems="center" gap={2} mb={3}>
                                                <Typography variant='subtitle1' fontWeight="600" color="#111827" sx={{ fontSize: '1.0625rem' }}>Driver Management</Typography>
                                                <Button
                                                    variant="outlined"
                                                    onClick={resetDriverData}
                                                    sx={{
                                                        minWidth: 10,
                                                        height: 40,
                                                        borderColor: '#d0d5dd',
                                                        color: '#344054',
                                                        fontWeight: 500,
                                                        textTransform: 'none',
                                                        borderRadius: 2,
                                                        '&:hover': { borderColor: '#98a2b3', bgcolor: '#f9fafb' }
                                                    }}
                                                >
                                                    Reset
                                                </Button>
                                            </Stack>

                                            <Stack spacing={3}>
                                                {/* Driver Selection */}
                                                <Box>
                                                    <InfiniteScrollList
                                                        dataFetcher={fetchDrivers}
                                                        optionSelectHandler={driverSelectHandler}
                                                        options={optionsListDriver}
                                                        value={updateDriverStatus?.fleetId}
                                                        label='Select Driver'
                                                    />
                                                    {errors?.DriverStatus && <FormHelperText error sx={{ mt: 0.5 }}>{errors?.DriverStatus}</FormHelperText>}
                                                </Box>

                                                {/* On Duty / Off Duty Buttons */}
                                                <Stack direction="row" spacing={1.5}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => {
                                                            handleDriveStatus(true)
                                                            setUpdateDriverStatus(prev => ({ ...prev, fleetOnDutyStatus: true }))
                                                        }}
                                                        sx={{
                                                            flex: 1,
                                                            height: 44,
                                                            bgcolor: '#16a34a',
                                                            color: '#ffffff',
                                                            fontWeight: 600,
                                                            textTransform: 'none',
                                                            borderRadius: 2.5,
                                                            boxShadow: '0 1px 2px rgba(22,163,74,0.1)',
                                                            '&:hover': { bgcolor: '#15803d', boxShadow: '0 4px 12px rgba(22,163,74,0.2)' }
                                                        }}
                                                    >
                                                        On Duty
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => {
                                                            handleDriveStatus(false)
                                                            setUpdateDriverStatus(prev => ({ ...prev, fleetOnDutyStatus: false }))
                                                        }}
                                                        sx={{
                                                            flex: 1,
                                                            height: 44,
                                                            bgcolor: '#6b7280',
                                                            color: '#ffffff',
                                                            fontWeight: 600,
                                                            textTransform: 'none',
                                                            borderRadius: 2.5,
                                                            boxShadow: '0 1px 2px rgba(107,114,128,0.1)',
                                                            '&:hover': { bgcolor: '#4b5563', boxShadow: '0 4px 12px rgba(107,114,128,0.2)' }
                                                        }}
                                                    >
                                                        Off Duty
                                                    </Button>
                                                </Stack>

                                                {/* Location Inputs */}
                                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        placeholder="Latitude"
                                                        value={updateDriverStatus.lat}
                                                        onChange={e => {
                                                            setUpdateDriverStatus(prev => ({ ...prev, lat: e.target.value }));
                                                            setErrors(prev => ({ ...prev, DriverLocation: '' }));
                                                        }}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: 2,
                                                                backgroundColor: '#ffffff',
                                                                '& fieldset': { borderColor: '#e5e7eb' },
                                                                '&:hover fieldset': { borderColor: '#d1d5db' },
                                                                '&.Mui-focused fieldset': { borderColor: '#0062ff', borderWidth: '2px' }
                                                            }
                                                        }}
                                                    />
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        placeholder="Longitude"
                                                        value={updateDriverStatus.long}
                                                        onChange={e => {
                                                            setUpdateDriverStatus(prev => ({ ...prev, long: e.target.value }));
                                                            setErrors(prev => ({ ...prev, DriverLocation: '' }));
                                                        }}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: 2,
                                                                backgroundColor: '#ffffff',
                                                                '& fieldset': { borderColor: '#e5e7eb' },
                                                                '&:hover fieldset': { borderColor: '#d1d5db' },
                                                                '&.Mui-focused fieldset': { borderColor: '#0062ff', borderWidth: '2px' }
                                                            }
                                                        }}
                                                    />
                                                </Stack>
                                                {errors?.DriverLocation && <FormHelperText error sx={{ mt: -1.5 }}>{errors?.DriverLocation}</FormHelperText>}

                                                {/* Update Location Button */}
                                                <Box>
                                                    <Button
                                                        variant="contained"
                                                        onClick={handleUpdateDriverLocationStatus}
                                                        sx={{
                                                            minWidth: 160,
                                                            height: 44,
                                                            bgcolor: '#0062ff',
                                                            color: '#ffffff',
                                                            fontWeight: 600,
                                                            textTransform: 'none',
                                                            borderRadius: 2.5,
                                                            boxShadow: '0 1px 2px rgba(0,98,255,0.1)',
                                                            '&:hover': { bgcolor: '#0052cc', boxShadow: '0 4px 12px rgba(0,98,255,0.2)' }
                                                        }}
                                                    >
                                                        Update Location
                                                    </Button>
                                                </Box>
                                            </Stack>
                                        </div>
                                    </Card>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Card sx={{
                            p: 3.5,
                            borderRadius: 3,
                            boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div className="right-panel">
                                <div className="map-container hd-wrapper">
                                    <Stack direction='row' alignItems='center' justifyContent='space-between' mb={3} flexWrap="wrap" gap={2}>
                                        <Typography variant='subtitle1' fontWeight="600" color="#111827" sx={{ fontSize: '1.0625rem' }}>On Duty Drivers</Typography>
                                      <Box direction='row' >

                                         <Button
                                            variant="contained"
                                            onClick={syncRegion}
                                            sx={{
                                                minWidth: 120,
                                                marginRight:3,
                                                height: 40,
                                                bgcolor: '#0062ff',
                                                color: '#ffffff',
                                                fontWeight: 600,
                                                textTransform: 'none',
                                                borderRadius: 2,
                                                boxShadow: '0 1px 2px rgba(0,98,255,0.1)',
                                                '&:hover': { bgcolor: '#0052cc', boxShadow: '0 4px 12px rgba(0,98,255,0.2)' }
                                            }}
                                        >
                                            {terminalLoading ? <CircularProgress size={18} color="inherit" /> : 'Sync KML Regions'}
                                        </Button> 
                                        <Button
                                            variant="contained"
                                            onClick={onDutyDrivers}
                                            sx={{
                                                minWidth: 120,
                                                height: 40,
                                                bgcolor: '#0062ff',
                                                color: '#ffffff',
                                                fontWeight: 600,
                                                textTransform: 'none',
                                                borderRadius: 2,
                                                boxShadow: '0 1px 2px rgba(0,98,255,0.1)',
                                                '&:hover': { bgcolor: '#0052cc', boxShadow: '0 4px 12px rgba(0,98,255,0.2)' }
                                            }}
                                        >
                                            {detailLoading ? <CircularProgress size={18} color="inherit" /> : 'Sync Driver Status'}
                                        </Button>
                                      </Box>
                                    </Stack>
                                    {detailLoading ? <Loader /> :
                                        <Table className='on-duty-drivers'>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <Typography className='text-12 text-left' style={{ color: "#2E2E3A", fontWeight: "600" }}>Driver Name</Typography>
                                                    </th>
                                                    <th>
                                                        <Typography className='text-12 text-left' style={{ color: "#2E2E3A", fontWeight: "600" }}>Region Name</Typography>
                                                    </th>
                                                    <th>
                                                        <Typography className='text-12 text-right' style={{ color: "#2E2E3A", fontWeight: "600" }}>Task Count</Typography>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    onDriverStatusList?.map((data) => {
                                                        return (
                                                            <tr key={data} onClick={() => dispatch(openCustomDrawer({ drawer: 'TESTING_DRAWER', drawerData: data }))}
                                                            >
                                                                <td>
                                                                    <Typography className='text-14' style={{ color: "#2E2E3A" }}>{data?.driverName}</Typography>
                                                                </td>
                                                                <td>
                                                                    <Typography className='text-14' style={{ color: "#2E2E3A" }}>{data?.regionName}</Typography>
                                                                </td>
                                                                <td>
                                                                    <Typography className='text-14' style={{ color: "#2E2E3A" }}>{data?.taskCount}</Typography>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </Table>
                                    }
                                </div>
                            </div>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </CommonLayout>
    )
}

export default IndexHyperdriveTesting